import {merge} from 'lodash';
import {portfolioUrl} from 'shared/portfolio/utils';
import req, {rejectCamelizedErrors, rejectGenericError} from 'shared/req';
import {objectId} from 'shared/utils';
import {flashMessage} from '../../../shared/actions/notifications';

export const NEW_TEST_SCORE = 'NEW_TEST_SCORE';
export const EDIT_TEST_SCORE = 'EDIT_TEST_SCORE';
export const CANCEL_EDIT_TEST_SCORE = 'CANCEL_EDIT_TEST_SCORE';

export const RECEIVE_TEST_SCORE = 'RECEIVE_TEST_SCORE';
export const DELETE_TEST_SCORE = 'DELETE_TEST_SCORE';

export const SCROLLED_TO_SCORE = 'SCROLLED_TO_SCORE';
export const RECEIVE_TEST_SCORES = 'RECEIVE_TEST_SCORES';

export function receiveTestScore(testScore) {
  return {
    type: RECEIVE_TEST_SCORE,
    testScore,
  };
}

export const newTestScoreObject = () => ({
  _id: objectId(),
  type: null,
  month: '',
  year: '',
  subtype: {},
  scores: {},
  editing: true,
  new: true,
});

export function newTestScore() {
  return {
    type: NEW_TEST_SCORE,
    testScore: newTestScoreObject(),
  };
}

export function scrolledToScore(id) {
  return {
    type: SCROLLED_TO_SCORE,
    id,
  };
}

export const saveTestScore =
  (testScore, shouldScroll = true) =>
  (dispatch, getState) => {
    const path = testScore.new ? '/test_scores' : `/test_scores/${testScore._id}`;
    const method = testScore.new ? 'POST' : 'PATCH';

    function successMessage() {
      dispatch(flashMessage('Test score saved!'));
    }

    const {
      student: {_id},
    } = getState();
    return req({
      url: portfolioUrl(path, _id),
      method: method,
      data: {...testScore, agent: 'api'},
    })
      .then((receivedTestScore) => {
        dispatch(receiveTestScore(merge({}, receivedTestScore, {scrollTo: shouldScroll})));
      })
      .then(successMessage)
      .catch(rejectCamelizedErrors)
      .catch(rejectGenericError);
  };

export function editTestScore(testScore) {
  return {
    type: EDIT_TEST_SCORE,
    testScore,
  };
}

export function cancelEditTestScore(testScore) {
  return {
    type: CANCEL_EDIT_TEST_SCORE,
    testScore,
  };
}

export function deleteTestScore(id) {
  return (dispatch, getState) => {
    const {
      student: {_id},
    } = getState();
    return req({
      url: portfolioUrl(`/test_scores/${id}`, _id),
      method: 'DELETE',
    }).then(() => {
      dispatch({
        type: DELETE_TEST_SCORE,
        id,
      });
    });
  };
}

export const getScoresByTestType = (defaultValue) => ({
  psat: {
    psatScoreMathematics: defaultValue ? 50 : '',
    psatScoreWriting: defaultValue ? 50 : '',
    psatScoreCriticalReading: defaultValue ? 50 : '',
  },
  psat2015: {
    psat2015ScoreWritingLanguage: defaultValue ? 300 : '',
    psat2015ScoreMathematics: defaultValue ? 300 : '',
  },
  sat: {
    satScoreCriticalReading: defaultValue ? 500 : '',
    satScoreMathematics: defaultValue ? 500 : '',
    satScoreWriting: defaultValue ? 500 : '',
    satScoreEssay: defaultValue ? 7 : '',
    satScoreMultipleChoice: defaultValue ? 50 : '',
  },
  sat2016: {
    sat2016ScoreMathematics: defaultValue ? 500 : '',
    sat2016ScoreReadingAndWriting: defaultValue ? 500 : '',
  },
  actPlan: {
    actPlanScoreEnglish: defaultValue ? 20 : '',
    actPlanScoreMathematics: defaultValue ? 20 : '',
    actPlanScoreReading: defaultValue ? 20 : '',
    actPlanScoreScience: defaultValue ? 20 : '',
  },
  preAct: {
    preActScoreEnglish: defaultValue ? 18 : '',
    preActScoreMathematics: defaultValue ? 18 : '',
    preActScoreReading: defaultValue ? 18 : '',
    preActScoreScience: defaultValue ? 18 : '',
  },
  act: {
    actScoreEnglish: defaultValue ? 20 : '',
    actScoreMath: defaultValue ? 20 : '',
    actScoreReading: defaultValue ? 20 : '',
    actScoreScience: defaultValue ? 20 : '',
  },
  ap: {apScore: defaultValue ? 3 : ''},
  other: {otherScore: ''},
});
